<template>
    <div class="tree-box">
        <el-select
          ref="treeSelect"
          style="width: 100%"
          v-model="valueLabel"
          :clearable="true"
          :placeholder="placeholder"
          :multiple="multiple"
          filterable
          :filter-method="filterable"
          @clear="handleClear"
          @remove-tag="handleRemoveTag"
          :disabled="disabled"
        >
            <el-option hidden value="value" label="label">
            </el-option>
            <el-tree
                ref="treeSelectTree"
                :accordion="true"
                :data="treeData"
                :props="props"
                :node-key="props.value"
                :highlight-current="!multiple"
                :show-checkbox="multiple"
                :check-strictly="true"
                :load="loadNode"
                :lazy="true"
                @node-click="handleNodeClick"
                @check="handleNodeCheckbox"
                :filter-node-method="filterNode"
            />
        </el-select>
    </div>
</template>
<script>
  import { debounce } from '@/utils'
  export default {
    name: 'TreeRelation',
    props: {
      disabled: {
        type: Boolean,
        default: false,
      },
      clearable: {
        type: Boolean,
        default: true,
      },
      limits: {
        type: [Array, Boolean],
        default: false,
      },
      placeholder: {
        type: String,
        default: '请选择',
      },
      value: {
        type: [Array],
        default: () => [],
      },
      multiple: {
        type: Boolean,
        default: true
      },
      eventCode: {
        type: String,
        default: '',
      },
      viewCode: {
        type: String,
        default: '',
      },
      nameField: {
        type: String,
        default: '',
      },
      descField: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        valueLabel: [],
        treeData: [],
        checkedNodes: [],
        props: {
          value: 'value',
          label: 'label',
          children: 'children',
          isLeaf: 'isLeaf'
        },
        multipleLimit: 15,
        node:{},
        resolveFunc: function (){},
      }
    },
    watch: {
      value(val) {
        if (val) this.init()
      },
      eventCode (val) {
        if (val) this.init()
      },
      viewCode (val) {
        if (val) this.init()
      }
    },
    mounted() {
      this.init()
    },
    methods: {
      init() {
        if (Array.isArray(this.value)) {
          this.checkedNodes = this.value
        } else {
          this.checkedNodes = []
        }
        if (this.multiple) {
          this.checkedNodes.map(item => {
            this.$refs.treeSelectTree.setChecked(item.id, true, false)
          })
        } else {
          this.$refs.treeSelectTree.setCurrentKey(this.checkedNodes.length > 0 ? this.checkedNodes[0] : undefined)
        }
        this.initValueLabel()
      },
      initValueLabel() {
        const labels = this.checkedNodes.map(item => item.label)
        if (this.multiple) {
          this.valueLabel = labels
        } else {
          this.valueLabel = labels.length > 0 ? labels[0] : undefined
        }
      },
      handleClear() {
        this.valueLabel = []
        this.checkedNodes = []
        if (this.multiple) {
          this.$refs.treeSelectTree.setCheckedKeys([])
        } else {
          this.$refs.treeSelectTree.setCurrentKey(null)
        }
        this.$emit('input', this.checkedNodes)
      },
      /* 树节点点击事件 */
      handleNodeClick(data, node) {
        if (!this.multiple) {
          this.checkedNodes = [data]
          this.valueLabel = data.label
        }
        if(node.childNodes?.length){
          node.expanded = true
        }
        this.$emit('input', this.checkedNodes)
      },
      handleNodeCheckbox(data, node) {
        const { checkedNodes } = node
        if (this.multiple) {
          if (this.multipleLimit >= checkedNodes.length) {
            this.checkedNodes = checkedNodes
            this.valueLabel = checkedNodes.map(i => i.label)
          } else {
            this.$refs.treeSelectTree.setChecked(data, false, true)
            this.$message.error('最多选择' + this.multipleLimit + '项')
          }
        }
        this.$emit('input', this.checkedNodes)
      },
      handleRemoveTag(tag) {
        const node = this.checkedNodes.find(item => item.label === tag)
        if (node) {
          this.$refs.treeSelectTree.setChecked(node.value, false, true)
        }
        this.checkedNodes = this.$refs.treeSelectTree.getCheckedNodes()
        this.$emit('input', this.checkedNodes)
      },
      loadNode(node, resolve) {
        if(node.level === 0) {
          this.node = node
          this.resolveFunc = resolve
          this.getTreeData(undefined, resolve)
        }
        if(node.level >= 1) {
          const { data: { value } } = node
          this.getTreeData(value, resolve)
        }
      },
      getTreeData(parentId, resolve) {
        const { viewCode, nameField, descField } = this
        const eventCode = this.eventCode
        if (!eventCode) return
        const getBizList = this.getApi()
        getBizList && getBizList(eventCode, {isTree:true, parentId, viewCode,idField:"id",nameField,descField,columns: [], pageNum: 1,pageSize: 999 }).then(res => {
          if (res.code === 200) {
            let treeData = null;
            if (descField) {
              treeData = res.data.list.map(k => {
                return { label: k.name, value: k.id, describe: k.describe,children: [],isLeaf:k.isLeaf}
              })
            } else {
              treeData = res.data.list.map(k => {
                return { label: k.name, value: k.id,children: [],isLeaf: k.isLeaf }
              })
            }
            console.log("tree-data:",treeData)
            resolve(treeData)
          }
        })
      },
      /* 树filter方法 */
      filterNode(value, data) {
        if (!value) return true
        return data[this.props.label].indexOf(value) !== -1
      },
      filterable: debounce( function(keyWords) {
        // 之后可以加入全局搜索改变treeData
        // 暂时支持多选
        if(this.multiple) {
          this.$refs.treeSelectTree.filter(keyWords)
        }
      }, 500),
      getApi() {
        const { option: { api } } = this.$attrs
        if (!api) return false
        const { getBizList } = api
        if (!getBizList) return false
        return getBizList
      }
    }
  }
</script>
  